import React from 'react';

const AirportHotelsResults = () => {
  return (
    <div id="App"></div>
  );
};

export default AirportHotelsResults; 